import type { Nodes, Root } from "mdast";

const OPEN_TAG = /^<u>$/i;
const CLOSE_TAG = /^<\/u>$/i;

const isTag = (node: Nodes, tag: RegExp) => node.type === "html" && tag.test(node.value.trim());

const wrapUnderline = (node: Nodes) => {
  if (!("children" in node)) return;

  node.children.forEach((child) => wrapUnderline(child as Nodes));

  const children: Nodes[] = [];
  const openings: number[] = [];

  (node.children as Nodes[]).forEach((child) => {
    if (isTag(child, OPEN_TAG)) {
      openings.push(children.length);
      return;
    }

    if (isTag(child, CLOSE_TAG)) {
      const start = openings.pop();
      if (start === undefined) return;

      const content = children.splice(start);
      children.push({ type: "emphasis", children: content, data: { hName: "u" } } as Nodes);
      return;
    }

    children.push(child);
  });

  (node as { children: Nodes[] }).children = children;
};

const remarkUnderline = () => (tree: Root) => {
  wrapUnderline(tree);
};

export default remarkUnderline;
